// splide
document.addEventListener('DOMContentLoaded', function () {
  var splideElems = document.querySelectorAll('.splide-vala');

  var bar = document.querySelector('.my-carousel-progress-bar-vala');

  splideElems.forEach(function(splideElem) {
    var splide = new Splide(splideElem, {
      type: 'slide',
      arrows: false,
      pagination: false,
      perPage: 4,
      perMove: 1,
      gap: 15,
      omitEnd: true,
      breakpoints: {
        1350: {
            arrows: true,
            pagination: false,
            perPage: 3,
            perMove: 2,
            padding: {
                left: 15,
                right: 15
            }
        },
        1024: {
            perPage: 2,
            perMove: 1
        },
        768: {
          perPage: 1,
          perMove: 1
      }
    }
}).mount();

    splide.on('mounted move', function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    });
  });
  });

  // timer
  function initializeVideoTimer() {
    var videos = document.querySelectorAll('.mm-vala-video');
    var timers = document.querySelectorAll('.mm-timer-video-vala');

    videos.forEach(function(video, index) {
      var checkDuration = setInterval(function() {
        if (video.readyState > 0) {
          clearInterval(checkDuration);
          var duration = Math.round(video.duration);
          var minutes = Math.floor(duration / 60);
          var seconds = duration % 60;
          timers[index].textContent = minutes + 'min ' + seconds + 'sec';
        }
      }, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', initializeVideoTimer);

// video
document.addEventListener('DOMContentLoaded', function() {
  var videoContainers = document.querySelectorAll('.mm-wrapper-card-vala');
  var justifyContentCard = document.querySelector('.mm-content-card-vala');
  var currentHoveredCard = null;
  var firstVideoContainer = videoContainers[0];
  var firstVideo = firstVideoContainer.querySelector('.mm-vala-video');
  firstVideo.play();
  firstVideoContainer.classList.add('mm-wrapper-card-vala-height');
  // firstVideoContainer.querySelector('.mm-content-card-vala').style.justifyContent = "space-between";
  currentHoveredCard = firstVideoContainer;

  videoContainers.forEach(container => {
      var video = container.querySelector('.mm-vala-video');

      container.addEventListener("mouseenter", (event) => {
          if (currentHoveredCard && currentHoveredCard !== container) {
              var currentHoveredVideo = currentHoveredCard.querySelector('.mm-vala-video');
              currentHoveredVideo.pause();
              currentHoveredCard.classList.remove('mm-wrapper-card-vala-height');
              // currentHoveredCard.querySelector('.mm-content-card-vala').style.justifyContent = "flex-end";
          }

          video.play();
          container.classList.add('mm-wrapper-card-vala-height');
          // container.querySelector('.mm-content-card-vala').style.justifyContent = "space-between";
          currentHoveredCard = container;
      });

      container.addEventListener("mouseleave", (event) => {
          video.pause();
      });
  });

  // displayCardProduct.style.display = "none";
  // justifyContentCard.style.justifyContent = "flex-end";
});

// sound
function mmToggleVideoSound(clickedElem) {
  // Choper la vidéo liée à notre bouton
  const videoContainer = clickedElem.closest('.mm-wrapper-card-vala');
  const videoElement = videoContainer.querySelector('.mm-vala-video');
  const videoSound = videoContainer.querySelector('.mm-sound')
  const videoMuted = videoContainer.querySelector('.mm-muted')

  //mute la video
  if(videoElement.muted == true) {
    // if la video est muted : on la unmute
    videoElement.muted = false;

    videoSound.style.display = 'block';
    videoMuted.style.display = 'none';
  } else {
    // else on la mute
    videoElement.muted = true;
    videoSound.style.display = 'none';
    videoMuted.style.display = 'block';
  }
}
